export function isObject<T = unknown>(
  object: unknown,
): object is Record<string, T> {
  return object != null && typeof object === 'object' && !Array.isArray(object);
}

export const isNestedObjectArray = <T>(
  items: Record<string, T>[] | T[],
): items is Record<string, T>[] =>
  items.every(
    (item) =>
      isObject(item) && Object.values(item).every((entry) => isObject(entry)),
  );

export const isObjectKey = <T extends object>(
  source: T,
  key: unknown,
): key is keyof T => typeof key === 'string' && key in source;
